<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <QuestionPage title="Where will you retire?">
    <QuestionAnswer
      title='In or around London.'
      class='answer-london'
      :onSelect='chooseLondon'
    />

    <QuestionAnswer
      title='Elsewhere in the UK.'
      class='answer-elsewhere'
      :onSelect='chooseElsewhere'
    />
  </QuestionPage>
</template>

<script>
import { mapMutations } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'

export default {
  components: {
    QuestionAnswer,
    QuestionPage
  },
  methods: {
    ...mapMutations([
      'goToNextPage',
    ]),
    chooseLondon: function () {
      this.goToNextPage();
    },
    chooseElsewhere: function () {
      this.goToNextPage();
    },
  }
};
</script>
